module.exports = __webpack_public_path__ + "static/media/homepage.f6d8def5.png";